/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Sidebar_ExpandInputs */

const en_directory_sidebar_expand = /** @type {(inputs: Directory_Sidebar_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand`)
};

const zh_directory_sidebar_expand = /** @type {(inputs: Directory_Sidebar_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展开`)
};

/**
* | output |
* | --- |
* | "Expand" |
*
* @param {Directory_Sidebar_ExpandInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_sidebar_expand = /** @type {((inputs?: Directory_Sidebar_ExpandInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Sidebar_ExpandInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_sidebar_expand(inputs)
	return zh_directory_sidebar_expand(inputs)
});
export { directory_sidebar_expand as "directory.sidebar.expand" }